export enum OpportunitiesRoute {
  empty = '',
  contracts = 'contracts',
  prospects = 'prospects',
  billings = 'billings',
  dashboard = 'dashboard'
}
